import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import { instalar, ehIOS } from '../utils/pwa';
import tokens from '../theme/tokens';

const Passo = ({ numero, children }) => (
  <Stack direction="row" spacing={1.5} alignItems="center">
    <Box sx={{ width: 26, height: 26, borderRadius: '50%', bgcolor: tokens.color.brandSoft, color: tokens.color.brand, display: 'grid', placeItems: 'center', fontWeight: 700, fontSize: 13, flexShrink: 0 }}>{numero}</Box>
    <Typography variant="body2">{children}</Typography>
  </Stack>
);

// Convite para instalar o Riviera FC como app (prompt nativo ou instruções do iPhone).
const InstallAppDialog = ({ open, onClose, onRecusar }) => {
  const [mostrarPassosIOS, setMostrarPassosIOS] = useState(false);

  useEffect(() => {
    if (open) setMostrarPassosIOS(false);
  }, [open]);

  const handleInstalar = async () => {
    const resultado = await instalar();
    if (resultado === 'manual') setMostrarPassosIOS(true);
    else onClose(resultado === 'accepted');
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)} fullWidth maxWidth="xs" PaperProps={{ sx: { overflow: 'hidden' } }}>
      <Box sx={{ bgcolor: tokens.color.ink, color: '#fff', textAlign: 'center', pt: 3, pb: 2.5, px: 3 }}>
        <Box component="img" src="/icons/icon-192.png" alt="Riviera FC" sx={{ width: 76, height: 76, borderRadius: 3, boxShadow: tokens.shadow.lg }} />
        <Typography variant="h6" sx={{ mt: 1.5 }}>Instalar o app Riviera FC</Typography>
        <Typography variant="body2" sx={{ opacity: 0.75 }}>Acesso rápido pela tela inicial, em tela cheia e com login por biometria.</Typography>
      </Box>
      <DialogContent>
        {mostrarPassosIOS || ehIOS() ? (
          <Stack spacing={1.5} sx={{ pt: 1 }}>
            <Passo numero={1}>Toque em <IosShareRoundedIcon sx={{ fontSize: 18, verticalAlign: 'text-bottom', color: tokens.color.info }} /> <strong>Compartilhar</strong> na barra do Safari.</Passo>
            <Passo numero={2}>Escolha <AddBoxOutlinedIcon sx={{ fontSize: 18, verticalAlign: 'text-bottom' }} /> <strong>Adicionar à Tela de Início</strong>.</Passo>
            <Passo numero={3}>Confirme em <strong>Adicionar</strong>. O ícone do Riviera FC aparece na sua tela.</Passo>
          </Stack>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ pt: 1 }}>
            O app ocupa pouco espaço, abre direto no painel e recebe as novidades da pelada. Você pode desinstalar quando quiser.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onRecusar} color="inherit">Agora não</Button>
        {!(mostrarPassosIOS || ehIOS()) ? (
          <Button variant="contained" startIcon={<GetAppRoundedIcon />} onClick={handleInstalar}>Instalar</Button>
        ) : (
          <Button variant="contained" onClick={() => onClose(false)}>Entendi</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default InstallAppDialog;
